import React, { useState, useRef, useEffect } from "react"
import { createPortal } from "react-dom"

const Tooltip = ({
	text,
	textOnClick,
	offsetBubble = "bottom-8",
	offsetBubblePointer = "top-6",
	maxWidth = '',
	children,
	...props
}) => {
	const [isVisible, setIsVisible] = useState(false)
	const [tooltipClicked, setTooltipClicked] = useState(false)
	const [coords, setCoords] = useState({ top: 0, left: 0 })
	const ref = useRef(null)

	const handleTooltipClicked = () => {
		let timer
		setTooltipClicked(true)

		if (isVisible) {
			timer = setTimeout(() => {
				setIsVisible(false)
			}, 2000)
		}

		return () => clearTimeout(timer)
	}

	useEffect(() => {
		if (isVisible && ref.current) {
			const rect = ref.current.getBoundingClientRect()
			setCoords({
				top: rect.top + window.scrollY,
				left: rect.left + rect.width / 2 + window.scrollX,
			})
		}
	}, [isVisible])

	const tooltipContent = (
		<div
			style={{
				position: "absolute",
				top: coords.top,
				left: coords.left,
				transform: "translate(-50%, -100%)",
				zIndex: 1000,
				pointerEvents: "none",
			}}
			className={`transition-opacity duration-300 ease-in-out ${
				isVisible ? "opacity-100 visible" : "opacity-0 invisible"
			} ${maxWidth}`}
		>
			<div
				className={`relative ${offsetBubble} bg-gray-800 text-white text-xxs py-1 px-2 ${maxWidth === '' && 'whitespace-nowrap'} rounded-md shadow-lg text-center`}
			>
				<div
					className={`z-0 absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-gray-800 rotate-45 ${offsetBubblePointer}`}
				></div>
				<span className="relative">
					{!tooltipClicked ? text : textOnClick ?? text}
				</span>
			</div>
		</div>
	)

	return (
		<div
			className="relative flex items-center justify-center"
			ref={ref}
			onMouseEnter={() => {
				setTooltipClicked(false)
				setIsVisible(true)
			}}
			onMouseLeave={() => setIsVisible(false)}
			{...props}
		>
			<div onClick={handleTooltipClicked}>{children}</div>
			{ typeof document !== "undefined" ? createPortal(tooltipContent, document.body) : null }
		</div>
	)
}

export default Tooltip
